export default __webpack_public_path__ + "img/trending_bottom2.93418ad5.jpg";